export default function SocialStrip() {
	<div id="social">
		<a href="https://twitch.tv/l33tstudio" target="_blank" rel="noreferrer"><i className="fab fa-twitch"></i></a>
		<a href="https://twitter.com/L33Tstudio" target="_blank" rel="noreferrer"><i className="fab fa-twitter"></i></a>
		<a href="https://youtube.com/channel/UCWqxuxTDCLq9dwTTdnzcdLQ" target="_blank" rel="noreferrer"><i className="fab fa-youtube"></i></a>
		<a href="https://www.instagram.com/l33tstudio" target="_blank" rel="noreferrer"><i className="fab fa-instagram"></i></a>
	</div>
}
